import styled from 'styled-components'

export const CompetitorContainer = styled.div`
  margin: 0 auto;
  max-width: 1280px;
`

export const ExpertContainer = styled.div`
  margin: 0 auto;
  max-width: 1280px;
`